import { AnyAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import NotificationSystem from 'react-notification-system';

export interface INotification extends NotificationSystem.Notification {
  message?: string;
}

export interface INotificationsState {
  newNotification: INotification | null;
}

export const initialState: INotificationsState = {
  newNotification: null
};

const notifications = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<INotification>) => {
      state.newNotification = action.payload;
    },
    disposeNotification: (state) => {
      state.newNotification = null;
    }
  }
});

export const showSuccessMessage = (message: string): AnyAction => {
  return notifications.actions.showNotification({ level: 'success', message });
};

export const showErrorMessage = (message: string): AnyAction => {
  return notifications.actions.showNotification({ level: 'error', message });
};

export const showWarningMessage = (message: string): AnyAction => {
  return notifications.actions.showNotification({ level: 'warning', message });
};

export default notifications.reducer;

export const { showNotification, disposeNotification } = notifications.actions;

export const caseReducers = notifications.caseReducers;
